const latestNews = "即日起，每月15日前，將更新下個月課程辦理情形。\n" +
    "本會11月底前，相關課程公告：\n" +
    "1.實體課程：LG110012、LG110013、CA110004。\n" +
    "2.除上述3場次課程外，其餘課程均為遠距教學。\n" +
    "3. 新增1場次線上課程：MU110009。\n" +
    "\n" +
    "詳細課程資訊，可依上述課程代碼，參考「課程查詢」相關說明。";

export default latestNews;